<ng-container *transloco="let t">
  @if (
    (bestVariants$ | async)?.length &&
    (cheapestVariant$ | async) &&
    (productOptions$ | async)
  ) {
    <span class="fixed-space-8" aria-hidden="true"></span>
    <h2 class="label text-gray-05">{{ t('txt_label_best_deails') }}</h2>
    <span class="fixed-space-4" aria-hidden="true"></span>
    <nav
      class="product-best-variants-component"
      [class.mobile]="(biggerThan$ | async)?.xs"
      [class.widescreen]="(biggerThan$ | async)?.mobileL">
      <ul class="flex flex-row variant-list">
        @if (cheapestVariant$ | async; as cheapestVariant) {
          <li
            class="flex flex-col variant-card"
            [class.selected]="isVariantSelected(cheapestVariant)">
            <div
              class="link popsy-negative mid-gray"
              (click)="switchVariant(cheapestVariant)">
              <span class="small bold">{{ t('chips_sort_lowest_price') }} </span>
              <span class="small">{{ (cheapestVariant.price | amount) || '-' }} </span>
            </div>
          </li>
        }
        @if (findingBestVariants$ | async) {
          <li class="flex flex-col variant-card skeleton">
            <popsy-skeleton class="skeleton link"></popsy-skeleton>
          </li>
          <span class="fixed-space-12" aria-hidden="true"></span>
        }
      </ul>
    </nav>
  }
</ng-container>
